/*
 * @Descripttion:
 * @Author: qhx
 * @Date: 2025-02-10 15:06:05
 */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Carousel, message, Radio, Tooltip } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/redux/hooks';
import { setCartCount } from '@/features/user/userSlice';
import PriceDialog from '../priceDialog';
import { hardLabelArr, softLabelArr ,sdkLabelArr} from '../../config';
import { pmsProductObject, filesObject } from '../../type';
import { addCartShopping, settleAccountsGoods ,getComputeNum} from '@/api/shopping';
import { orderCountTotal } from '@/api/personal-center';
import addImg from '../../img/add-count.png';
import reduceImg from '../../img/reduce-count.png';
import payIcon from '../../img/pay-icon.png';
import payIcon1 from '../../img/pay-icon1.png';
import payIcon2 from '../../img/pay-icon2.png';
import payIcon3 from '../../img/pay-icon3.png';
import infoImg from '../../img/info-img.png';
import { openCustomerService } from '@/utils';
import {useLocation, useSearchParams } from "react-router-dom";
import './index.scss';
interface IProps {
  detailInfo: any;
  productSn: string | null;
  priceChange: any;
  priceSdkChange: any;
  detailInfoFunc: any;
  addCart: boolean;
  setAddCart: any;
  buyFlag: boolean;
  setBuyFlag: any;
}
// 定义子组件暴露给父组件的方法接口
export interface ProductParamsMethods {
  getPriceFunc: () => void;
}

const ProductParams = forwardRef<ProductParamsMethods, IProps>((props, ref) => {
  const {
    detailInfo,
    productSn,
    priceChange,
    priceSdkChange,
    detailInfoFunc,
    addCart,
    setAddCart,
    buyFlag,
    setBuyFlag,
  } = props;
  const navigate = useNavigate();
  const carouselRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const containerRef = useRef(null);
  const introRef = useRef(null);
  const location = useLocation();
  const [searchParams] = useSearchParams(location.search);
  const unit = searchParams.get('unit')??'';

  const [hoverIndex, setHoverIndex] = useState(0);
  const [serviceValue, setServiceValue] = useState(1); // 保障服务选择
  const [warrantyValue, setWarrantyValue] = useState(-1); // 延长保修选择
  const [buyCount, setBuyCount] = useState(1); // 购买数量
  const [priceModal, setPriceModal] = useState(false); // 获取价格弹窗
  const [typeIndex, setTypeIndex] = useState(0); // 规格型号选择
  const [safeOptions, setSafeOptions] = useState([]); // 保障服务
  const [warrantyOptions, setWarrantyOptions] = useState([]); // 延长保修
  const [addFlag, setAddFlag] = useState(true); // 是否能增加购买数量
  const [reduceFlag, setReduceFlag] = useState(false); // 是否能减少购买数量
  const [maxCount, setMaxCount] = useState(0); // 最大数量
  const [warrantyText, setWarrantyText] = useState(''); // 延保选择
  const [typeInfo, setTypeInfo] = useState<pmsProductObject[]>([]); // 所选规格商品信息
  const [typeId, setTypeId] = useState(-1); // 规格型号id
  const [isClick, setIsClick] = useState(true); // 加入购物车按钮防抖
  const [typeSdkInfo, setTypeSdkInfo] = useState<pmsProductObject[]>([]); // sdk所选规格商品信息
  const [sdkTypeId, setSdkTypeId] = useState(-1);//// 规格型号id
  const [sdkTimeId, setSdkTimeId] = useState(-1);//// 年月id
  const [sdkTypeIndex, setSdkTypeIndex] = useState(unit?Number(unit)!==0?1:0:0); // sdk规格型号选择0:免费，1收费
  const [sdkTimeIndex, setSdkTimeIndex] = useState(0); // sdk年月选择,0月，1年
  const [timeCount, setTimeCount] = useState(1); // 选择的月数或年数
  const [hasFee, setHasFee] = useState(true);
  const [priceSdkInfo, setPriceSdkInfo] = useState<any>();
  const [num, setNum] = useState<string>();
  // const [yearMaxCount, setyearMaxCount] = useState(0); // sdk年最大数量
  // const [monthMaxCount, setMonthMaxCount] = useState(0); // sdk月最大数量
  const getProduct = detailInfo?.product ?? {};
  const dispatch = useAppDispatch();
  let timeInter: any;

  //  轮播配置
  const settings = {
    className: 'slider variable-width',
    dots: false,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
  };
  useEffect(() => {
    if (detailInfo) {
      setTypeIndex(0);
      const typeModels: pmsProductObject[] = [];
      const pmsModels: any = [];
      const warModals: any = [];
      const sdkModels: any = [];//sdk、api规格型号
      let getCount = 0;
      if (detailInfo.pmsProductAttributeModels?.length > 0) {
        detailInfo.pmsProductAttributeModels.forEach(
          (pData: pmsProductObject) => {
            //[1:规格型号；2:保障服务；3：延长保修]feeType:2,免费、专业
            if (pData.type === 1 && pData.feeType !== '2') { //规格型号
              typeModels.push(pData);
            } else if (pData.type === 2) {
              pmsModels.push({
                value: pData.id,
                label: (
                  <div key={pData.id}>
                    <span className='service-label' title={pData.models}>
                      {pData.models}
                    </span>
                  </div>
                ),
              });
            } else if (pData.type === 3) {
              pData.isSelect = false;
              warModals.push(pData);
            } else if (pData.feeType === '2') {  //sdk规格型号：免费、专业
              sdkModels.push(pData);
              
            }
          }
        );
        getCount = detailInfo.pmsProductAttributeModels[0]?.productStock;
        setMaxCount(getCount);
        if (getCount <= 1) {
          setAddFlag(false);
        }
        if (detailInfo?.product?.productType === 3) { 
        // 判断接口数据是否包含unit ===='0',规格免费的情况
        const isZero = hasUnitZero(detailInfo.pmsProductAttributeModels);
          setHasFee(isZero);
          handleComputeNum();
        }
        
      }
      setWarrantyText(warModals[0]?.models ?? '');
      setServiceValue(pmsModels[0]?.value);
      setSafeOptions(pmsModels);
      setWarrantyOptions(warModals);
      setTypeInfo(typeModels);
      setTypeId(typeModels[0]?.id);
      setTypeSdkInfo(sdkModels);
      setSdkTypeId(sdkModels[0]?.id);
      // if (detailInfo?.product?.productType === 3) {
      //   if (sdkModels.length > 0) {
      //     priceSdkChange(sdkModels[0]?.models, priceSdkInfo?.price,1);
      //   }
      // } else { 

        if (typeModels.length > 0) {
          priceChange(typeModels, 0, 1, getCount);
        }
      // }
      
    }
  }, [JSON.stringify(detailInfo)]);
  useEffect(() => { 
    if (unit &&typeSdkInfo.length>0) { 
      setSdkTypeId(typeSdkInfo[sdkTypeIndex]?.id);
      pmsSdkFeeChange(typeSdkInfo[sdkTypeIndex],sdkTypeIndex);
    }
  },[unit,typeSdkInfo,sdkTypeIndex])
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    if (addCart) {
      addCartFunc();
    }
  }, [addCart]);
  useEffect(() => {
    if (buyFlag) {
      nowBuyFunc();
    }
  }, [buyFlag]);
  
 // 监听相关状态变化
  useEffect(() => {
    if (detailInfo?.product?.productType === 3) { 
// 状态更新后可以在这里调用 getSdkPrice 函数
const latestPrice = getSdkPrice();
console.log(latestPrice,'priceInfobefire')
setPriceSdkInfo(latestPrice);
priceSdkChange(typeSdkInfo[sdkTypeIndex]?.models, latestPrice?.price,latestPrice?.unit,timeCount);
// 可以添加其他逻辑，如更新其他状态等
    }
  
 }, [hasFee, sdkTypeIndex, sdkTimeIndex, typeSdkInfo, timeCount]);
  
  const handleComputeNum = () => { 
    getComputeNum().then((gRes: any) => {
      if (gRes.success) {
        setNum(gRes.obj?.num);
      }
    })
  }

  // 判断接口数据是否包含unit ===='0',规格免费的情况
  const hasUnitZero=(arr:any)=> {
    return arr.some((innerArray:any) => 
      innerArray?.subscribe.some((item:any) => item?.unit === '0') // 使用可选链避免报错
    );
  }
  const handleScroll = () => {
    const container: any = containerRef.current;
    const introContainer: any = introRef.current;
    if (container) {
      const scrollTop = window.scrollY;
      const containerTop = container?.getBoundingClientRect().top;
      const introHeight = introContainer.offsetHeight;
      const conHeight = container.offsetHeight;
      if (
        scrollTop > containerTop + 156 &&
        scrollTop < introHeight - conHeight
      ) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }
  };
  const handleMouseEnter = (index: number) => {
    setHoverIndex(index);
  };

  const handleMouseLeave = (index: number) => {
    setHoverIndex(index);
  };

  const changeBuyCount = (flag: number) => {
    // 购买数量
    let getCount = buyCount;
    if (getCount <= 1 && flag === 0) {
      return;
    }
    if (maxCount === 1 && flag === 1) {
      message.info('购买数量超出商品库存，请修改后操作');
      return;
    }
    if (flag === 0) {
      if (getCount <= maxCount) {
        setAddFlag(true);
      }
      if (getCount <= 1) {
        setReduceFlag(false);
        return;
      } else {
        if (getCount === 2) {
          setReduceFlag(false);
        }
      }
      getCount--;
    } else {
      if (getCount >= 1) {
        setReduceFlag(true);
      }

      if (maxCount > getCount) {
        if (getCount === maxCount - 1) {
          setAddFlag(false);
          message.info('购买数量超出商品库存，请修改后操作');
        } else {
          setAddFlag(true);
        }
        getCount++;
      } else {
        setAddFlag(false);
      }
    }
    setBuyCount(getCount);
    priceChange(typeInfo, typeIndex, getCount, maxCount);
  };

  // 修改时间
  const changeTimeCount = (flag: number) => {
    console.log(flag)
    // 购买数量
    let getCount = timeCount;
    if (getCount <= 1 && flag === 0) {
      return;
    }
    if (maxCount === 1 && flag === 1) {
      message.info('购买数量超出商品库存，请修改后操作');
      return;
    }
    if (flag === 0) {
      if (getCount <= maxCount) {
        setAddFlag(true);
      }
      if (getCount <= 1) {
        setReduceFlag(false);
        return;
      } else {
        if (getCount === 2) {
          setReduceFlag(false);
        }
      }
      getCount--;
    } else {
      if (getCount >= 1) {
        setReduceFlag(true);
      }

      if (maxCount > getCount) {
        if (getCount === maxCount - 1) {
          setAddFlag(false);
          // message.info('购买数量超出商品库存，请修改后操作');
        } else {
          setAddFlag(true);
        }
        getCount++;
      } else {
        setAddFlag(false);
      }
    }
    setTimeCount(getCount);
    // priceSdkChange(typeSdkInfo[sdkTypeIndex]?.models, priceSdkInfo?.price,timeCount);
  };
  // 获取价格
  const getPriceFunc = () => {
    setPriceModal(true);
  };
  // 选择服务
  const serviceChange = ({ target: { value } }: RadioChangeEvent) => {
    setServiceValue(value);
  };

  // 延长保修
  const warrantyChange = (pData: pmsProductObject) => {
    if (pData.isSelect) {
      setWarrantyValue(-1);
      setWarrantyText('');
    } else {
      setWarrantyValue(pData.id);
      setWarrantyText(pData.models);
    }

    const getOptions = [...warrantyOptions];
    getOptions.map((wRes: pmsProductObject) => {
      if (wRes.id === pData.id) {
        wRes.isSelect = !wRes.isSelect;
      } else {
        wRes.isSelect = false;
      }
    });
    setWarrantyOptions(getOptions);
  };
  const changeModal = (flag: boolean) => {
    if (!flag) {
      detailInfoFunc();
    }
    setPriceModal(flag);
  };
  const pmsChange = (data: pmsProductObject, index: number) => {
    // 规格型号选择
    setBuyCount(1);
    setTypeIndex(index);
    priceChange(typeInfo, index, buyCount, data.productStock);
    setMaxCount(data.productStock);
    setReduceFlag(false);
    setTypeId(data.id);
    if (data.productStock <= 1) {
      setAddFlag(false);
    } else {
      setAddFlag(true);
    }
  };

  // sdk规格切换
  const pmsSdkFeeChange = (data: any, index: number) => {
    // 规格型号选择
    setSdkTypeIndex(index);
    // priceChange(typeInfo, index, buyCount, data.productStock);
    setSdkTypeId(data.id);
    setTimeCount(1);
    // priceSdkChange(typeSdkInfo[index]?.models, priceSdkInfo?.price,1);
    if (index === 1) { 
   
      setMaxCount(data?.subscribe[sdkTimeIndex]?.maxNum );
      setReduceFlag(false);
      setSdkTypeId(data.id);
      if (data?.subscribe[sdkTimeIndex]?.maxNum <= 1) {
        setAddFlag(false);
      } else {
        setAddFlag(true);
      }
    }
    // sdk详情页面，切换到专业版按年后，再切换到免费版后，会存在未选中的情况
    if(index === 0){
      setSdkTimeIndex(0)
    }
  
  };
  // 点击年月
  const pmsSdkProChange = (data: any, index: number) => { 
    setSdkTimeIndex(index);
     //按月按年
     setTimeCount(1);
    //  priceSdkChange(typeSdkInfo[sdkTypeIndex]?.models, priceSdkInfo?.price,1);
      setMaxCount(data?.maxNum);
      setReduceFlag(false);
      setSdkTimeId(data.id);
      if (data?.maxNum <= 1) {
        setAddFlag(false);
      } else {
        setAddFlag(true);
      }
    
  }
  const handleService = (event: any) => {
    event?.stopPropagation();
    openCustomerService();
  };
  // 加入购物车
  const addCartFunc = () => {
    setAddCart(false);
    if (!isClick) {
      message.warning('请勿频繁操作');
      return;
    }
    clearTimeout(timeInter);
    setIsClick(false);
    timeInter = setTimeout(() => {
      setIsClick(true);
    }, 3000);
    const setRelates = [typeId];
    if (serviceValue) {
      setRelates.push(serviceValue);
    }
    if (warrantyValue !== -1) {
      setRelates.push(warrantyValue);
    }
    const params = {
      productId: getProduct?.id,
      quantity: buyCount,
      relates: setRelates,
    };
    addCartShopping(params).then((aRes: any) => {
      if (aRes.success) {
        message.success('添加购物车成功！');
        cartCountFunc();
      } else {
        message.error(aRes.message);
      }
    });
  };
  // 获取购物车数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes: any) => {
      if (oRes.success) {
        dispatch(setCartCount(oRes.obj?.cartNum ?? 0));
      }
    });
  };
  // 立即购买
  const nowBuyFunc = () => {
    let saveData:any = [];
    if (getProduct?.productType === 3) {//sdk、api
      setBuyFlag(false);
      console.log(sdkTypeId,'sdkTypeId')
      const setRelates = [sdkTypeId];
      if (serviceValue) {
        setRelates.push(serviceValue);
      }
      if (warrantyValue !== -1) {
        setRelates.push(warrantyValue);
      }
      const models = setRelates
        .map((id) =>
          detailInfo.pmsProductAttributeModels.find((item: any) => item.id === id)
        )
        .filter((item: any) => item !== undefined)
        .map((item: any) => ({ ...item, price:  getSdkPrice()?.price }));
       
     saveData = [
        {
          models: models,
          pmsFiles: detailInfo.pmsFiles,
          price:getSdkPrice().price,
          productId: getProduct.id,
          productName: getProduct.name,
          productSn: getProduct.productSn,
          quantity: timeCount,
         relates: setRelates,
         prices: [getSdkPrice()?.id],
         unit:getSdkPrice().unit,
        },
      ];
    } else { 
      setBuyFlag(false);
      const setRelates = [typeId];
      if (serviceValue) {
        setRelates.push(serviceValue);
      }
      if (warrantyValue !== -1) {
        setRelates.push(warrantyValue);
      }
      const models = setRelates
        .map((id) =>
          detailInfo.pmsProductAttributeModels.find((item: any) => item.id === id)
        )
        .filter((item: any) => item !== undefined);
     saveData = [
        {
          models: models,
          pmsFiles: detailInfo.pmsFiles,
          price: typeInfo[typeIndex]?.price,
          productId: getProduct.id,
          productName: getProduct.name,
          productSn: getProduct.productSn,
          quantity: buyCount,
          relates: setRelates,
        },
      ];
    }
   
    setCacheAndJump(saveData);
  };
  // 跳转到结算
  const setCacheAndJump = (data: any) => {
    settleAccountsGoods(data).then((sRes: any) => {
      if (sRes.success) {
        navigate('/user/confirm?type=detail');
      } else {
        message.error(sRes.message);
      }
    });
  };

  const getSdkPrice = () => { 
    if (hasFee) {
      if (sdkTypeIndex === 0) {
        return typeSdkInfo[0]?.subscribe[0];
      } else {
        return typeSdkInfo[1]?.subscribe[sdkTimeIndex];
      }
    } else { 
      return typeSdkInfo[sdkTypeIndex]?.subscribe[sdkTimeIndex];
    }
    
  }
  // 获取购买方式
  const getBuyWay = (type:string) => {
    switch (type) { 
      case '0':
        return '永久授权';
      case '1':
        return '日';
      case '2':
        return '周';
      case '3':
        return '月';
      case '4':
        return '季';
      case '5':
        return '年';
      case '10':
        return '次';
      break;
        
    }
  }
//  console.log(typeSdkInfo,'typeSAdkInfon')
 // 向父组件暴露方法
  useImperativeHandle(ref, () => ({
    getPriceFunc
  }));
  console.log(getProduct, 'getProduct');
  return (
    <div className='goods-main'>
      <div
        className={`goods-content ${isSticky ? 'sticky' : ''}`}
        ref={containerRef}
      >
        <div
          className={`${getProduct?.productType === 2 && 'goods-select-soft'} goods-select`}
        >
          {detailInfo.pmsFiles?.length > 0 && (
            <img src={detailInfo?.pmsFiles[hoverIndex].url} alt='' />
          )}
        </div>
        <div className='goods-carousel'>
          <Carousel {...settings} ref={carouselRef}>
            {(detailInfo.pmsFiles ?? []).map(
              (cData: filesObject, index: number) => (
                <div
                  className={`list-content ${index === hoverIndex && 'list-select'}`}
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={() => handleMouseLeave(index)}
                  key={cData.id}
                >
                  <img src={cData.url} alt='' />
                </div>
              )
            )}
          </Carousel>
        </div>
      </div>
      <div className='goods-intro-content' ref={introRef}>
        <h1 style={{marginTop:'40px'}} title={getProduct?.name}>{getProduct?.name}</h1>
        <p>
          {JSON.parse(getProduct?.serviceIds ?? '[]').map(
            (sData: string, index: number) => (
              <span key={index} className='key-word'>
                {sData}&nbsp;&nbsp;
              </span>
            )
          )}
        </p>
        <div className='goods-label'>
          {getProduct?.productType === 1 ? (
            <>
              {hardLabelArr.map((sData: string, index: number) => (
                <span key={index}>{sData}</span>
              ))}
            </>
          ) :(getProduct?.productType === 3? (<>
            {sdkLabelArr.map((sData: string, index: number) => (
              <span key={index}>{sData}</span>
            ))}
          </>):
            <>
              {softLabelArr.map((sData: string, index: number) => (
                <span key={index}>{sData}</span>
              ))}
            </>
          )}
        </div>
        <div className='price-show'>
          {(getProduct?.productType===1||getProduct?.productType===2)?(typeInfo.length > 0 &&
          typeInfo[typeIndex]?.price !== '' &&
          typeInfo[typeIndex]?.price ? (
            <>
              <span>￥</span>
              <mark>
                {typeInfo[typeIndex]?.price}/{typeInfo[typeIndex]?.unit}
              </mark>
              {typeInfo[typeIndex]?.originalPrice && (
                <span className='original-price'>
                  ￥{typeInfo[typeIndex]?.originalPrice}/
                  {typeInfo[typeIndex]?.unit}
                </span>
              )}
            </>
          ) : (
            <>
              {/* <mark
                onClick={() => getPriceFunc()}
                style={{ fontSize: '28px', cursor: 'pointer' }}
              >
                点击获取价格
              </mark> */}
              <span className='price-get'>
                商品价格需根据具体需求确定，请先与我们联系
              </span>
              <div className='attention-container'>
                <button className='com-btn' onClick={(event) => handleService(event)}>在线沟通</button>
                <button className='price-btn' onClick={() => getPriceFunc()}>立即获取价格</button>
                {getProduct?.focus ? (
                  <p className='attention-count'>
                    已有{getProduct?.focus}人关注
                  </p>
                ) : (
                  ''
                )}
              </div>
            </>
          )):((getSdkPrice()?.price!==''&&getSdkPrice()?.price)?( <>
            <span>￥</span>
            <mark className='price-mark'>
                {(sdkTypeIndex === 1 && timeCount > 1) ? (timeCount*Number(getSdkPrice()?.price)).toFixed(2) : getSdkPrice()?.price}
            </mark>
            { (sdkTypeIndex===1&&timeCount>1)&&<span className='only-one'><span className='line'>|</span>单价<span>￥</span>{getSdkPrice()?.price}</span>}
          </>):(<>
              <span className='price-get'>
              商品价格需根据具体需求确定，请先与我们联系
              </span>
              <div className='attention-container'>
                <button className='com-btn' onClick={(event) => handleService(event)}>在线沟通</button>
                <button className='price-btn' onClick={() => getPriceFunc()}>立即获取价格</button>
                {getProduct?.focus ? (
                  <span className='attention-count'>
                    已有{getProduct?.focus}人关注
                  </span>
                ) : (
                  ''
                )}
              </div>
            </>))}
        </div>
        <div className='pay-content'>
          <div className='pay-title'>
            <div className='title-name'>
              <span>品牌名称：</span>
              <span className='brand-name'>{getProduct.brand}</span>
            </div>
            <div className='name-right'>
              商品货号：<span>{productSn}</span>
            </div>
          </div>
          <div className='pay-title'>
            <div className='title-name'>
              销售单位：<span>{getProduct?.productType !==3?typeInfo[typeIndex]?.unit:typeSdkInfo[sdkTypeIndex]?.unit}</span>
            </div>
            <div>
              包装数量：<span>{getProduct?.productType !==3?typeInfo[typeIndex]?.packSize:typeSdkInfo[sdkTypeIndex]?.packSize}</span>
            </div>
          </div>
          {(getProduct?.productType ===3||(typeInfo[typeIndex]?.price !== '' && typeInfo[typeIndex]?.price)) && (
            <div className='pay-title'>
              支付方式：
              <img src={payIcon} alt='' />
              <span>对公转账</span>
              <img src={payIcon1} alt='' />
              <span>支付宝</span>
              <img src={payIcon2} alt='' />
              <span>微信</span>
              <img src={payIcon3} alt='' />
              <span>云闪付</span>
            </div>
          )}
         {getProduct?.productType !==3 && <div className='pay-title'>
            发货日期：
            <span>交易完成后预计{typeInfo[typeIndex]?.sendDate}前完成发货</span>
            <Tooltip
              placement='right'
              title={
                '系统根据商品库存信息判断的预计发货日期，可能会受诸多因素影响产生偏差 ，若在订单支付完成前变更商品发货日期，我们将积极为您备货处理。'
              }
              getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
            >
              <img className='date-tips' src={infoImg} alt='' />
            </Tooltip>
          </div>}
          {getProduct?.productType === 3&&<div className="pay-title" style={{alignItems:'initial'}}>
          注意事项：
            <span style={{width:'477px'}}>该商品不支持退款；授权码仅支持对{num}台电脑设备激活授权，如有更多需要，请与我们联系</span>
          </div>}
        </div>
        {getProduct?.productType === 1 && typeInfo.length > 0 && (
          <>
            <h2>规格型号</h2>
            <div className='model-list'>
              {typeInfo.map((pData: pmsProductObject, pIndex: number) => (
                <>
                  {pData.type === 1 && (
                    <span
                      className={`${typeIndex === pIndex && 'select'}`}
                      key={pIndex}
                      onClick={() => pmsChange(pData, pIndex)}
                      title={pData.models}
                    >
                      {pData.models}
                    </span>
                  )}
                </>
              ))}
            </div>
          </>
        )}
        
        {/* sdk规格型号 */}
        {getProduct?.productType === 3 && typeSdkInfo.length > 0 && (
          <>
            <>
              <h2>规格型号</h2>
              <div className='model-list'>
                {typeSdkInfo.map((pData: pmsProductObject, pIndex: number) => (
                  <>
                    {pData.feeType === '2' && (
                      <span
                        className={`${sdkTypeIndex === pIndex && 'select'}`}
                        key={pIndex}
                        onClick={() => pmsSdkFeeChange(pData, pIndex)}
                        title={pData.models}
                      >
                        {pData.models}
                      </span>
                    )}
                  </>
                ))}
              </div>
            </>
            {/* 专业版 */}
            {getSdkPrice()?.unit!=='0'&&<>
              <h2>购买方式</h2>
              <div className='model-list'>
                {typeSdkInfo?.filter((modelsItem: any) => modelsItem?.models === '专业版')[0]?.subscribe?.map((subItem: any, sIndex: number) => (
                  <>
                
                    <span
                      className={`${sdkTimeIndex === sIndex && 'select'}`}
                      key={sIndex}
                      onClick={() => pmsSdkProChange(subItem, sIndex)}
                      title={subItem.models}
                    >
                      按{getBuyWay(subItem?.unit)}
                    </span>
              
                  </>
                ))}
              </div>
            </>}
             {/* 免费版 */}
             {getSdkPrice()?.unit==='0'&&<>
              <h2>购买方式</h2>
              <div className='model-list'>
                {typeSdkInfo?.filter((modelsItem: any) => modelsItem?.models === '免费版')[0]?.subscribe?.map((subItem: any, sIndex: number) => (
                  <>
                
                    <span
                      className={`${sdkTimeIndex === sIndex && 'select'}`}
                      key={sIndex}
                      // onClick={() => pmsSdkProChange(subItem, sIndex)}
                      title={subItem.models}
                    >
                      {getBuyWay(subItem?.unit)}
                    </span>
              
                  </>
                ))}
              </div>
              
            </>}
          </>
        )}
        {getProduct?.productType === 2 && (
          <>
            {getProduct?.appScenes && (
              <>
                <h2>应用场景</h2>
                <div className='scene-label'>
                  {JSON.parse(getProduct?.appScenes).map(
                    (sData: string, sIndex: number) => (
                      <span key={sIndex}>{sData}</span>
                    )
                  )}
                </div>
              </>
            )}
            {typeInfo.length > 0 && (
              <>
                <h2>版本</h2>
                <div className='version-show'>
                  {typeInfo.map((pData: pmsProductObject, pIndex: number) => (
                    <span
                      className={`${typeIndex === pIndex && 'select'}`}
                      key={pIndex}
                      onClick={() => pmsChange(pData, pIndex)}
                      title={pData.models}
                    >
                      {pData.models}
                    </span>
                  ))}
                </div>
              </>
            )}
          </>
        )}

        {safeOptions.length > 0 && (
          <>
            <h2>保障服务</h2>
            <Radio.Group
              value={serviceValue}
              className='premium-radio'
              options={safeOptions}
              onChange={serviceChange}
            />
          </>
        )}

        {warrantyOptions.length > 0 && (
          <>
            <h2>延长保修</h2>
            <div className='warranty-list'>
              {warrantyOptions.map((wRes: pmsProductObject) => (
                <div
                  key={wRes.id}
                  className={`${wRes.isSelect && 'select'} war-list`}
                  onClick={() => warrantyChange(wRes)}
                >
                  <span className='service-label' title={wRes.models}>
                    {wRes.models}
                  </span>
                  <span className='premium-count'>￥ {wRes.price}</span>
                </div>
              ))}
            </div>
          </>
        )}

        {detailInfo?.product?.productType === 3 ? (<>
        <div className='buy-select'>
            {/* {maxCount > 0 ?
             (  */}
            <>
              {getSdkPrice()?.unit!=='0' &&<div className='sdk-count-box'>
                <img
                  className={`${!reduceFlag && 'buy-gray'}`}
                  src={reduceImg}
                  onClick={() => changeTimeCount(0)}
                  alt=''
                />
                <span className='buy-count'>{timeCount}</span>
                <img
                  className={`${!addFlag && 'buy-gray'}`}
                  src={addImg}
                  onClick={() => changeTimeCount(1)}
                  alt=''
                />&nbsp;&nbsp;<span className='time-text'>{getBuyWay(getSdkPrice()?.unit)}</span>
              </div>
                // : <h2 className='fee-buy-way'>购买方式<p className=''>永久授权</p></h2>
              }
                  <span className='buy-sdk-now' onClick={() => nowBuyFunc()}>
                    立即购买
                  </span>
                </>
            </div>
        
        </>) : (typeInfo.length > 0 &&
        typeInfo[typeIndex]?.price !== '' &&
        typeInfo[typeIndex]?.price ? (
          <>
            {maxCount > 0 && <h2>购买数量</h2>}
            <div className='buy-select'>
              {maxCount > 0 ? (
                <>
                  <img
                    className={`${!reduceFlag && 'buy-gray'}`}
                    src={reduceImg}
                    onClick={() => changeBuyCount(0)}
                    alt=''
                  />
                  <span className='buy-count'>{buyCount}</span>
                  <img
                    className={`${!addFlag && 'buy-gray'}`}
                    src={addImg}
                    onClick={() => changeBuyCount(1)}
                    alt=''
                  />
                  <span className='add-cat' onClick={() => addCartFunc()}>
                    加入购物车
                  </span>
                  <span className='buy-now' onClick={() => nowBuyFunc()}>
                    立即购买
                  </span>
                </>
              ) : (
                <span className='no-count'>暂无库存</span>
              )}
            </div>
          </>
        ) : (
          // <div
          //   className='consult-now-btn'
          //   onClick={(event) => handleService(event)}
          // >
          //   <span>立即咨询</span>
          // </div>
          <></>
        ))}
      </div>
      <PriceDialog
        priceModal={priceModal}
        typeInfo={typeInfo}
        title={getProduct?.name}
        imgUrl={
          detailInfo.pmsFiles?.length > 0 ? detailInfo.pmsFiles[0]?.url : ''
        }
        productSn={productSn}
        typeIndex={typeIndex}
        changeModal={changeModal}
      />
    </div>
  );
});

export default ProductParams;
